import {
  convertToLocalStyle,
  helpbuttonStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getReachEstimateStyles = (_, { palette }) => ({
  reachEstimateControl: {
    width: 350,
    marginBottom: 10,
  },

  estimateHelpContent: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: '#292827',
  },

  estimateNote: {
    color: '#323130',
    fontSize: 12,
    width: 302,
    fontWeight: 400,
    lineHeight: '16px',
    marginTop: 10,
    height: 50,
  },

  panel: {
    minHeight: 161,
    position: 'relative',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    borderRadius: 2,
    backgroundColor: `${palette && palette.white}`,
  },

  panelBody: {
    padding: 16,
  },

  reachEstimateTitle: {
    /* Potential available reach */
    width: 302,
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    /* identical to box height */
    display: 'flex',
    alignItems: 'center',
    color: '#323130',
  },

  impressionsCountMessage: {
    fontSize: 18,
    fontWeight: 'bold',
    '& a': {
      alignContent: 'center',
    },
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
  },

  impressionsCount: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '36px',
    color: '#323130',
  },

  meterContainer: {
    margin: '0px 0 13px 0',
    position: 'relative',
    fontSize: 12,
    top: -24,
    '& .specificMeter': {
      zIndex: 1,
      width: '10%',
      height: 24,
      backgroundColor: '#D13438',
      position: 'absolute',
      top: 17,
    },
    '& .broadMeter': {
      width: '90%',
      backgroundColor: '#C4C4C4',
      height: 24,
      position: 'absolute',
      top: 17,
      marginLeft: '10%',
    },
  },

  specificMeter: {
    width: '10%',
    height: 12,
    backgroundColor: '#C4C4C4',
    position: 'absolute',
    top: 17,
  },

  broadMeter: {
    width: '90%',
    backgroundColor: '#D13438',
    height: 24,
    position: 'absolute',
    top: 17,
    marginLeft: '10%',
  },

  audienceSpecificLabel: {
    position: 'absolute',
    top: 35,
    fontSize: 12,
  },

  audienceBroadLabel: {
    position: 'absolute',
    top: 35,
    fontSize: 12,
    right: 0,
  },

  arrow: {
    backgroundColor: 'white',
    top: 17,
    width: 1,
    height: 24,
    position: 'absolute',
    border: `4px solid ${palette.white} !important`,
    zIndex: 1,
  },
});
